<template>
  <Modal id="open-shop" :value="openModal" width="590" :mask-closable="false" :closable="false">
    <div slot="header" class="ivu-modal-header-title">
      <div>{{lang.openShop.header}}</div>
      <a class="ivu-modal-close" @click="close"><Icon type="md-close" size="16" /></a>
    </div>
    <div class="shop-body clearfix">
      <Alert type="warning" show-icon>{{lang.openShop.warning}}</Alert>
      <Form :model="formdata" :label-width="100" class="shop-form">
        <FormItem required>
          <span slot="label" v-html="lang.openShop.form.name"></span>
          <Row>
            <Col span="12">
            <Input ref="form-name" v-model.trim="formdata.name" :maxlength="30" :placeholder="lang.openShop.form.name_h" @on-blur="onlyCheck"></Input>
            </Col>
            <Col span="12">
            <div v-if="formerror.name" class="form-error">
              <Icon type="md-alert"></Icon>{{formerror.name}}</div>
            <div v-if="!formerror.name && nameok" class="form-ok">
              <Icon type="checkmark-circled"></Icon>{{lang.openShop.msg.name_can_use}}</div>
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="lang.openShop.form.brief">
          <Input v-model="formdata.brief" type="textarea" :rows="4" :placeholder="lang.openShop.form.brief_h" :maxlength="200"></Input>
        </FormItem>
        <FormItem :label="lang.openShop.form.address" required>
          <Row>
            <Cascader ref="cityAddress" class="ivu-col-span-12" :data="areaList" @on-change="areaChange" :clearable="false" :placeholder="lang.openShop.form.area_h"></Cascader>
            <Col span="12">
            <div v-if="formerror.province || formerror.city || formerror.address" class="form-error">
              <Icon type="md-alert"></Icon>{{formerror.province || formerror.city || formerror.address}}</div>
            </Col>
          </Row>
          <Input ref="form-address" v-model.trim="formdata.address" :placeholder="lang.openShop.form.address_h" :maxlength="50"></Input>
        </FormItem>
        <FormItem>
          <Checkbox v-model="agree"><span class="agree">{{lang.openShop.form.agree}}</span></Checkbox>
        </FormItem>
        <FormItem>
          <Button type="success" :disabled="!agree" shape="circle" size="small" @click="openShop" style="width: 170px;margin-right: 15px;">{{lang.openShop.btn_ok}}</Button>
          <Button type="primary" ghost shape="circle" size="small" @click="close" style="width: 170px;">{{lang.actions.cancel}}</Button>
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>
<script>
import { Modal, Button, Alert, Form, FormItem, Input, Cascader, Checkbox, Row, Col, Icon } from 'iview'
import { actions, openShop, message } from '../../locale'
import { Area } from '../../utils'
import { formValid } from './method'

const formrules = {
  name: [
    { required: true, message: openShop.msg.required },
    { minLength: 2, message: openShop.msg.minLength2 }
  ],
  province: [
    { required: true, message: openShop.msg.required }
  ],
  city: [
    { required: true, message: openShop.msg.required }
  ],
  address: [
    { required: true, message: openShop.msg.required }
  ]
}

export default {
  name: 'Openshop',
  components: {
    Modal,
    Button,
    Alert,
    Form,
    FormItem,
    Input,
    Cascader,
    Checkbox,
    Row,
    Col,
    Icon
  },
  model: {
    prop: 'open',
    event: 'updateOpen'
  },
  data() {
    return {
      lang: { actions, openShop },
      formdata: {},
      formerror: {},
      agree: false,
      areaList: Area,
      lastformdata: '',
      nameok: false,
      notcheck: false // 关闭弹出框时不再做check，避免反复失去焦点
    }
  },
  props: {
    open: Boolean
  },
  computed: {
    openModal: {
      get() {
        return this.open
      },
      set(val) {
        this.$store.state.openShopModal = val
      }
    }
  },
  methods: {
    init() {
      this.formdata = {}
      this.lastformdata = this.formSerialize()
      if (this.$refs.cityAddress) {
        this.$refs.cityAddress.clearSelect()
      }
      this.formerror = {}
      this.agree = false
      this.nameok = false
      this.notcheck = false
    },
    close() {
      this.notcheck = true
      if (this.lastformdata != this.formSerialize()) {
        global.$Modal.confirm({
          title: message.title.alert,
          content: message.content.unsave,
          onOk: () => {
            // 清空onbeforeunload事件，防止带到其他路由页面
            window.onbeforeunload = null
            this.openModal = false
            this.init()
          }
        })
      } else {
        this.openModal = false
        this.init()
      }
    },
    areaChange(value, selectedData) {
      if (selectedData.length == 2) {
        this.formdata.province = selectedData[0].label
        this.formdata.city = selectedData[1].label
      } else {
        this.formdata.province = null
        this.formdata.city = null
      }
    },
    onlyCheck() {
      if (this.notcheck) {
        return false
      }
      let resultValid = formValid({ 'name': this.formdata.name }, { 'name': formrules.name })
      if (resultValid) {
        this.$set(this.formerror, 'name', resultValid.name)
        if (this.$refs['form-name'] && this.$refs['form-name'].focus) {
          this.$refs['form-name'].focus()
        }
        return
      } else {
        this.$set(this.formerror, 'name', null)
      }

      // 店名唯一性检查
      let formData = new FormData()
      formData.append('name', this.formdata.name)
      global.$ComAxios.post('market:/shop/name/check', formData).then(response => {
        if (response.status == 200) {
          if (response.data && response.data.status == 200) {
            this.$set(this.formerror, 'name', null)
            this.nameok = true
          } else if (response.data.status == 301002) {
            this.nameok = false
            this.$set(this.formerror, 'name', openShop.msg.name_only)
            this.$refs['form-name'].focus()
          } else {
            this.$Message.error(response.data.msg)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    openShop() {
      this.formerror = formValid(this.formdata, formrules)
      if (this.formerror) {
        for (let key in this.formerror) {
          if (this.$refs['form-' + key] && this.$refs['form-' + key].focus) {
            this.$refs['form-' + key].focus()
          }
          break
        }
        return false
      } else {
        this.formerror = {}
      }

      // 开店
      global.$ComAxios.post('market:/shop/create', this.formdata).then(response => {
        if (response.status == 200) {
          if (response.data && response.data.status == 200) {
            this.lastformdata = this.formSerialize()
            // 保存成功，关闭弹出框，刷新用户菜单
            this.$store.state.shop.id = response.data.result.id
            this.openModal = false
            // 跳转到店铺设置页面
            window.location.href = global.$ComDomain.Modules.seller
          } else if (response.data.status == 301002) {
            this.formerror = { name: openShop.msg.name_only }
          } else {
            this.$Message.error(response.data.msg)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    formSerialize() {
      // 表单json
      let jsonArray = {}
      for (let key in this.formdata) {
        if (this.formdata[key] != null && this.formdata[key] !== '') {
          jsonArray[key] = this.formdata[key]
        }
      }
      return JSON.stringify(jsonArray)
    }
  },
  created() {
    this.init()
    window.onbeforeunload = () => {
      if (this.lastformdata != this.formSerialize()) {
        // 有可保存数据，不可跳转
        return false
      }
    }
  }
}

</script>
<style lang="less">
#open-shop .ivu-modal {
  .ivu-modal-body {
    font-size: 14px;
  }
  .ivu-modal-footer {
    display: none;
  }
  .ivu-form-item {
    margin-bottom: 20px;
  }
  .ivu-form-item-required .ivu-form-item-label:before {
    content: "\B7";
    font-size: 24px;
    width: 16px;
    position: relative;
    top: 4px;
    line-height: 0;
  }
  .shop-body {
    padding-bottom: 20px;
    .shop-form {
      margin: 30px 35px 0px 35px;
      textarea {
        resize: none;
      }
      .form-error, .form-ok {
        line-height: 30px;
        margin-left: 20px;
        i {
          font-size: 16px;
          line-height: 30px;
          padding-right: 10px;
        }
      }
      .form-error {
        color: #e71f19;
      }
      .form-ok {
        color: #4fe491;
      }

    }
    .agree {
      color: #141414;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/openShop/OpenShop.vue